import React from "react";
import { motion } from "framer-motion";
import { FiAlertCircle } from "react-icons/fi";
import { useReducedMotion } from "@/hooks/useReducedMotion";
import styles from "./ErrorDisplay.module.css";

interface ErrorDisplayProps {
  message: string;
  onRetry?: () => void;
  retryText?: string;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  message,
  onRetry,
  retryText = "Try Again",
}) => {
  const prefersReducedMotion = useReducedMotion();

  const shakeVariants = {
    initial: { x: 0 },
    shake: prefersReducedMotion
      ? {}
      : {
          x: [-10, 10, -10, 10, 0],
          transition: {
            duration: 0.5,
          },
        },
  };

  const containerVariants = {
    hidden: { opacity: 0, y: prefersReducedMotion ? 0 : -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: prefersReducedMotion ? 0 : 0.3,
      },
    },
  };

  return (
    <motion.div
      className={styles.errorContainer}
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.div
        className={styles.iconContainer}
        variants={shakeVariants}
        initial="initial"
        animate="shake"
      >
        <FiAlertCircle className={styles.icon} />
      </motion.div>

      <p className={styles.message}>{message}</p>

      {onRetry && (
        <motion.button
          className={styles.retryButton}
          onClick={onRetry}
          whileHover={!prefersReducedMotion ? { scale: 1.05 } : {}}
          whileTap={!prefersReducedMotion ? { scale: 0.95 } : {}}
        >
          {retryText}
        </motion.button>
      )}
    </motion.div>
  );
};
